import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "@/shared/api/http-client";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        // Retry policy is scoped to ApiError specifically. Other error
        // shapes (bare Error, TypeError on network failure) fall through to
        // a generic retry budget — network errors benefit from one retry.
        if (error instanceof ApiError) {
          if (error.status === 401 || error.status === 403 || error.status === 404) {
            return false;
          }
          if (error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < 2;
        }
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
